import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-citation-formatter',
  templateUrl: './citation-formatter.component.html',
  styleUrls: ['./citation-formatter.component.scss']
})
export class CitationFormatterComponent implements OnInit {

  steps: string[] = ['Step 1', 'Step 2', 'Step 3', 'Step 4'];
  currentStep: number = 0;
  interval: any;
  timer: any;

  slideImages = [
    '/assets/images/features/citation-formatter/copy-citation.webp',
    '/assets/images/features/citation-formatter/target-styles.webp',
    '/assets/images/features/citation-formatter/indiviual-citation.webp',
    '/assets/images/features/citation-formatter/final-document.webp',
  ];

  constructor(
      private titleService: Title,
      private metaTagService: Meta,
      private LinkService: LinkService,
      @Inject(PLATFORM_ID) private platformId: Object
    ) { }

  ngOnInit() {
    this.titleService.setTitle('免費引文格式整理器，支援 MLA、APA、AMA、ACS、Elsevier 等多種格式');
    this.metaTagService.updateTag({ name: 'description', content: "使用 Trinka 引文格式整理器，一次快速完成整份參考文獻的格式調整，並即時驗證引用的準確性與一致性！" });
    this.metaTagService.updateTag({ property: 'og:title', content: '免費引文格式整理器，支援 MLA、APA、AMA、ACS、Elsevier 等多種格式' });
    this.metaTagService.updateTag({ property: 'og:description', content: "使用 Trinka 引文格式整理器，一次快速完成整份參考文獻的格式調整，並即時驗證引用的準確性與一致性！" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/citation-formatter' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/Citation-Formatter.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '免費引文格式整理器，支援 MLA、APA、AMA、ACS、Elsevier 等多種格式' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "使用 Trinka 引文格式整理器，一次快速完成整份參考文獻的格式調整，並即時驗證引用的準確性與一致性！" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/features/Citation-Formatter.png' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'citation checker, reference checker, apa checker, apa citation checker, check citation online, apa format checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/citation-formatter' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/citation-formatter' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/citation-formatter' });
    
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.timer) {
      clearInterval(this.timer);
    }
  }

  startTimer() {
    if (isPlatformBrowser(this.platformId)) {
      this.timer = setInterval(() => {
        this.nextStep();
      }, 4000);
    }
  }

  resetTimer(stepIndex: number) {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.timer);
      this.currentStep = stepIndex;
      this.startTimer();
    }
  }

  nextStep() {
    this.currentStep = (this.currentStep + 1) % this.steps.length;
  }

}
